import React from 'react';

import { FormControl, Input } from '@mui/material';

import { ESTIMATE_VALUE } from '../../constants/Dashboard/Financing';

import './EstimateValueInput.css';

export const EstimateValueInput = ({ estimateValue, handleEstimateValueChange }) => {
  return (
    <div className="estimate-value-input-wrapper">
      <FormControl sx={{ m: 0, minWidth: 320, width: '97.5%' }}>
        <div className="value-input-tab-wrapper">
          <div className="estimate-input-wrapper">
            <p className="estimate-label-wrapper">{ESTIMATE_VALUE}</p>
            <Input
              id="estimate-value-input"
              autoComplete="off"
              // putting the styles as part of id doesn't override the style
              style={{ width: '100%' }}
              value={estimateValue}
              onChange={(e) => {
                if (!isNaN(e.target.value)) {
                  handleEstimateValueChange(e.target.value);
                } else {
                  handleEstimateValueChange('');
                }
              }}
              disableUnderline
            ></Input>
          </div>
        </div>
      </FormControl>
    </div>
  );
};
